import { useCallback } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Button } from '../../Button'
import { Flex } from '../../Flex'
import { Text } from '../../Text'
import Section from '../../Section/Section'

export default function CategoryBar({
    category: currentCategory,
    categories,
    onChange,
}) {
    const { t } = useTranslation('blog')
    const handleOnChange = useCallback(
        (id) => () => onChange && onChange(id),
        []
    )
    // console.log(currentCategory)
    return (
        <Section py={10}>
            <Text mb={4}>{t('topics')}</Text>
            <Flex>
                {categories.map((category) => (
                    <Button
                        key={category.node?.id}
                        size="xs"
                        mr={1}
                        variant={
                            currentCategory === category.node?.id
                                ? 'primary'
                                : 'ghost'
                        }
                        onClick={handleOnChange(category.node?.id)}
                    >
                        {category.node?.name}
                    </Button>
                ))}
            </Flex>
        </Section>
    )
}
